import template from "./text.html";
import "./text.less";

import {
	EVENT_CLEAR_VALUE,
	EVENT_UNCLEAR_VALUE,
	EVENT_REVERT_VALUES,
	EVENT_REPORT_LOCKED,
	EVENT_REPORT_UNLOCKED,
	EVENT_SET_FORM_PRISTINE
} from "constants.js";
import {
	find,
	some
} from "lodash";
import fieldHelpers from "../../../field-helpers/lookup.config";
import { IS_NOT_AVAILABLE_OPTIONS } from "../../../../constants";

export class Controller {
	lookups = [];

	constructor($scope, eventBus, featureHelper, $logger, uiHelpers, $timeout) {
		this._scope = $scope;
		this.featureHelper = featureHelper;
		this.$logger = $logger;
		this.uiHelpers = uiHelpers;
		this.$timeout = $timeout;
	}

	$onInit() {
		this._eventBus = this.reportScope.events;
		this._unregister = this.reportFormCtrl.registerFieldController(this);

		this.initialValue = find(this.values, v => v.FieldId === this.field.Id);
		this.initialValue && (this.initialValue.IsNotAvailable = !!this.initialValue.IsNotAvailable); //coerce isnotavailable to false if it doesn't exist

		this.setValue();
		this.setFeatures();

		this.hasHelperButtons = !!this.lookups.length;

		if(this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.always)) {
			this.setNotAvailable(this.isNotAvailable);
		}

		this._eventBus.register(EVENT_CLEAR_VALUE(this.field.Id), (e, params) => {
			if(!this.cleared && !!this.value && params.isInitializing !== true) {
				this.cleared = {
					value: this.value
				};

				this.value = undefined;
			}

			if(this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.always)) {
				this.isNotAvailable = false;
				this.setNotAvailable(this.isNotAvailable);
			}
		}, this._scope);

		this._eventBus.register(EVENT_UNCLEAR_VALUE(this.field.Id), () => {
			if(!!this.cleared) {
				this.value = this.cleared.value;
			}
		}, this._scope);

		this._eventBus.register(EVENT_REVERT_VALUES, () => {
			this.revertValue();
		}, this._scope);

		this._eventBus.register(EVENT_REPORT_LOCKED, () => {
			this.field.isReadonly = true;
			this.disableField();
		}, this._scope);

		this._eventBus.register(EVENT_REPORT_UNLOCKED, () => {
			this.field.isReadonly = false;
			this.enableField();

			if(this.isNotAvailable || this.isCustomInput) {
				this.isNotAvailable && this.disableHelpers(fieldHelpers.NotAvailable.name);
				this.isCustomInput && this.disableHelpers(fieldHelpers.CustomInput.name);
			}
		}, this._scope);

		this._eventBus.register(EVENT_SET_FORM_PRISTINE, () => {
			this.setPristine();
		}, this._scope);
	}

	$onDestroy() {
		this._unregister();
	}

	getCurrentValue(isApiCall) {
		let result = this.buildResult();

		if(!isApiCall && this.field.IsNotReported !== true && this.field.IsHidden !== true) {
			if(result === undefined) {
				result = {
					FieldId: this.field.Id,
					IsNotAvailable: !!this.isNotAvailable,
					hasResultForRuleRun: !!this.isNotAvailable
				};
			}
			result.isDirty = this.value !== (this.initialValue?.String) ||
				this.initialValue?.isNotAvailable !== result.isNotAvailable ||
				result.DataId !== this.initialValue?.DataId;
		}

		return result ? [result] : [];
	}

	checkForDirty() {
		const isDirty = (this.field.visible !== false || this.initialValue !== undefined) && (this.value !== this.initialValue?.String);
		this.setFieldDirty(this.field.Id, isDirty);
	}

	handleInput() {
		const content = this.value;
		if((/^[ -~]*$/.test(content))) { //regex matches all ASCII characters except for backspace
		} else {
			this.value = content.replace(/[^ -~]/g, ""); //regex replaces characters that are not ASCII - backspace with an empty string
		}
	}

	revertValue() {
	}

	setPristine() {
		this.initialValue = this.field.IsDetail ? undefined : this.buildResult();
	}

	buildResult() {
		if(!!this.isNotAvailable || this.value) {
			return {
				FieldId: this.field.Id,
				IsNotAvailable: !!this.isNotAvailable,
				DataId: !!this.isNotAvailable ? this.selection?.Id : undefined,
				String: !!this.isNotAvailable ? undefined : this.value
			};
		}

		return undefined;
	}

	setValue(val) {
		if(val) {
			this.value = val;
			return;
		}

		const value = find(this.values, v => v.FieldId === this.field.Id);

		if(value) {
			this.value = value.String;
			this.selectValue = value.DataId;
			this.isNotAvailable = value.IsNotAvailable;
		}
	}

	getValidationStyling() {
		return this.field.hasValidationError ? "validation-error"
			: this.field.hasValidationWarning ? "validation-warning" : "";
	}

	setFeatures() {
		this.setupIsNotAvailableFeature();

		if(this.field.isDisabled || this.field.isReadonly) {
			this.disableHelpers();
		}
		else {
			this.isNotAvailable && this.disableHelpers(fieldHelpers.NotAvailable.name);
		}
	}

	setupIsNotAvailableFeature() {
		this.showNotAvailableSelections = false;
		if(this.featureHelper.checkNotAvailable(this.field, IS_NOT_AVAILABLE_OPTIONS.always)) {
			const feature = this.featureHelper.getNotAvailableFeature(this.field, this.isNotAvailable, (selection) => this.setNotAvailable(selection));
			this.lookups.push(feature);

			this.options = this.field.Data;
		}
	}

	setBox(box) {
		this.box = box;

		this.setOptions();

		if(this.selection) {
			this.box.setValueByChoice(this.selection.Id.toString());
		}
	}

	setOptions() {
		if(this.selection && !some(this.options, (o) => o.Id === this.selection.Id)) {
			if(this.box) {
				const values = this.box.getValue(true);
				this.box.removeItemsByValue(values);
			}

			this.selection = {};

			this.value = undefined;
			this.handleValueChanged();
		}

		this.setChoices();

		if((this.options || []).length === 1) {
			this.selection = this.options[0];

			this.value = this.selection.Id;
			this.setChoice(this.selection);
		}
	}

	setChoices(data) {
		if(data) {
			this.options = data;
		}

		if(!this.options || !Array.isArray(this.options)) {
			this.box.clearStore();
			return;
		}

		const activeOptions = this.options.filter((option) => option.IsActive || option.IsActive === undefined);

		const selectionChoices = this.uiHelpers.setDisplay(
			activeOptions,
			{
				recentlyUsedEnabled: this.field.IsRecentlyUsedEnabled,
				hideCode: this.field.IsCodeHidden
			}
		);

		if(this.box) {
			this.box.setChoices(selectionChoices, "value", "label", true);
		}
	}

	disableHelpers(exceptedName) {
		this.enableHelpers();
		this.lookups.forEach(l => {
			if(this.reportFormCtrl.readonly || !exceptedName || l.name !== exceptedName) {
				l.disabled = true;
			}
		});
	}

	enableHelpers() {
		this.lookups.forEach(l => l.disabled = false);
	}

	setNotAvailable(isActive) {
		this.isNotAvailable = isActive;
		this.showNotAvailableSelections = false;
		this.updateCustomInputState(this.isNotAvailable);

		if(this.isNotAvailable) {
			this.value = "";
			this.field.isDisabled = !(this.field.Data && this.field.Data.length > 0);
			this.disableHelpers(fieldHelpers.NotAvailable.name);
			if(this.field.Data && this.field.Data.length > 0) {
				this.showNotAvailableSelections = true;
				this.updateSelectValue();
			}
		}
		else if(!this.field.isReadonly) {
			this.field.isDisabled = false;
			this.enableHelpers();
			this.selection = null;
			this.selectValue = undefined;
		}
	}

	updateCustomInputState(newState) {
		const inputLookup = find(this.lookups, (lookup) => lookup.name === fieldHelpers.NotAvailable.name);
		inputLookup.selection = newState;
	}

	handleLookupSelection(lookup) {
		if(lookup.action) {
			lookup.action(lookup.selection);
		}
	}

	handleValueChanged(modelVal) {
		this.selectValue = modelVal;
		this.updateSelectValue();

		this.checkForDirty();
	}

	updateSelectValue() {
		if(this.selectValue !== undefined) {
			this.selection = find(this.options, (o) => o.Id === parseInt(this.selectValue));

			if(this.selection) {
				this.field.isDisabled = false;
				this.enableField();
			}

			if(!this.selection && this.selectValue !== "") {
				this.selection = { Id: this.selectValue };
			}
		}
	}

	enableField() {
		if(!this.field.isDisabled && !this.field.isReadonly) {
			// checks if it is a select box, OR
			// if it is a text field that is available.
			if(this.options || this.isNotAvailable) {
				this.field.placeHolder = null;
				this.box && this.box.enable();

				this.$timeout(() => {
					this.enableHelpers();
				});
			}
		}
	}

	disableField() {
		if(this.field.isDisabled || this.field.isReadonly) {
			this.box && this.box.disable();
			this.disableHelpers();
		}
	}

	setDisplay(id) {
		const item = find(this.options, { Id: parseInt(id) });

		if(!item)
			throw new Error(`Selected ${this.field.Name} not found as an option.`);

		return item.Name || item.Code;
	}
}

export default angular
	.module("vesl.components.report-form.text", [])
	.component("text", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			pivotColumn: "=",
			pivotRow: "=",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm",
			reportScope: "^^reportScope"
		}
	}).name;
